import { Settings2Icon, Unplug, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  HOME,
  getUserMenu,
  getUserProfil,
  resetStorage,
} from "../../Utils/Utils";
import BurgerIcon from "../../assets/icons/burger-menu-black.svg";
import LOGO from "../../assets/images/mtn.png";
import { menuAdmin } from "../../layout/AppMenu";
import { logout } from "../../services/service";

export const SideBarMenu = ({ menu }) => {
  const navigate = useNavigate();
  const [openSidebar, setOpenSidebar] = useState(false);

  const user = getUserProfil();
  const menuMobile = getUserMenu();
  return (
    <>
      <div className="font-mtn hidden pl-1 py-1 h-screen lg:block sticky top-0 left-0 z-[999999]">
        <div className="bg-[#000000] rounded-xl relative flex flex-col justify-between px-4 pt-5 w-full h-full ">
          <div className="flex flex-row justify-start px-2 gap-2 items-center ">
            <img src={LOGO} className="w-9 rounded-2xl " alt="" />
            <span className="text-lg text-white font-extrabold">MTN Fibre</span>
          </div>
          <div className="mb-auto flex flex-col overflow-y-auto">
            <div className="mt-5 main-menu w-full flex flex-col justify-center">
              {menu
                ?.sort(function (a, b) {
                  return a?.sousMenu?.numeroOrdre - b?.sousMenu?.numeroOrdre;
                })
                ?.map((item) => (
                  <NavLink
                    key={item?.sousMenu?.route}
                    to={HOME + item?.sousMenu?.route}
                    onClick={() => {
                      localStorage.setItem(
                        "action",
                        JSON.stringify(item?.actions)
                      );
                      localStorage.setItem(
                        "sousMenuSelected",
                        JSON.stringify(item)
                      );
                    }}
                  >
                    <button className="font-mtn my-[0.5px] px-3 flex items-center gap-x-2 w-full h-11 rounded-lg text-gray-300 font-normal">
                      {
                        menuAdmin.find((e) => e.link === item?.sousMenu?.route)
                          ?.icon
                      }
                      <span className="text-left text-sm lg:text-[13px] ">
                        {item?.sousMenu?.description}
                      </span>
                    </button>
                  </NavLink>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white/70  backdrop-blur-md shadow flex-row flex justify-between  py-2 w-full fixed lg:hidden items-center z-50">
        <button
          onClick={() => {
            navigate(HOME + "/abonnements");
          }}
          className="flex flex-row justify-start px-2 gap-2 items-center "
        >
          <img src={LOGO} alt="" className="w-9 rounded-2xl" />
          <span className="text-lg text-gray-600 font-extrabold">
            MTN Fibre
          </span>
        </button>
        <button
          className="w-10 h-10 rounded-full top-5 left-4 flex items-center justify-center"
          onClick={() => setOpenSidebar(true)}
        >
          <img src={BurgerIcon} alt="" className="w-6 " />
        </button>
      </div>

      {/* SIDEBAR */}
      {openSidebar ? (
        <div className="absolute inset-0 w-full h-screen z-[999] mb-16">
          <div
            className="absolute inset-0 w-full min-h-screen bg-black/30"
            onClick={() => setOpenSidebar(false)}
          ></div>

          <div className="block lg:hidden fixed top-0 left-0 min-w-[280px] w-[280px] h-full bg-[#01192e] drop-shadow-lg z-[999999]">
            <div className="overflow-y-auto px-2  w-full flex flex-col justify-between h-full">
              <div>
                <div className="mt-4 flex justify-between items-center">
                  <div className="flex flex-row justify-start px-2 gap-2 items-center ">
                    <img alt="" src={LOGO} className="w-9 rounded-full" />
                    <span className="text-lg text-white font-extrabold">
                      MTN Fibre
                    </span>
                  </div>
                  <button
                    className="bg-gray-50 w-8 h-8 rounded-full z-[999] flex items-center justify-center text-white"
                    onClick={() => setOpenSidebar(false)}
                  >
                    <X size={20} className="text-black" />
                  </button>
                </div>
                <div className="flex flex-col">
                  <div className="mt-5 main-menu w-full flex flex-col justify-center">
                    <div className="border-none join join-vertical w-full">
                      {menuMobile
                        ?.sort(function (a, b) {
                          return a?.menu?.numeroOrdre - b?.menu?.numeroOrdre;
                        })
                        ?.map((item) => (
                          <div className="collapse collapse-arrow join-item">
                            <input type="radio" name="my-accordion-4" />
                            <div className="collapse-title text-md font-medium text-white">
                              {item?.menu?.description}
                            </div>
                            <div className="collapse-content">
                              {item?.sousMenus?.map((sousMenu) => (
                                <NavLink
                                  key={sousMenu?.sousMenu?.route}
                                  to={HOME + sousMenu?.sousMenu?.route}
                                >
                                  <button className="my-[0.5px] px-3 flex items-center gap-x-2 w-full h-11 rounded-lg text-gray-300 font-normal">
                                    {
                                      menuAdmin.find(
                                        (e) =>
                                          e.link === sousMenu?.sousMenu?.route
                                      )?.icon
                                    }
                                    <span className="text-left text-xs lg:text-[13px] ">
                                      {sousMenu?.sousMenu?.description}
                                    </span>
                                  </button>
                                </NavLink>
                              ))}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col w-full bg-[#ffffff1b] p-2 gap-2 mb-2 rounded-lg">
                <div className="flex flex-row gap-2 items-center ">
                  <img src={LOGO} alt="" className="w-6 rounded-2xl" />
                  <h2 className="text-xs font-normal text-white">
                    {user?.nomPrenoms} ({user?.roles[0].split("ROLE_")})
                  </h2>
                </div>
                <Link
                  to={HOME + "/profil"}
                  className="flex items-center gap-2 text-xs btn btn-sm"
                >
                  <Settings2Icon size={16} />
                  Modifier mes accès
                </Link>
                <Link
                  to={HOME + "/login"}
                  onClick={() => {
                    logout(user?.username);
                    resetStorage();
                  }}
                  className="text-sm font-mtn border-none flex  justify-center items-center p-1 px-2 rounded-lg gap-2 hover:bg-none bg-[#D50000] text-white"
                >
                  <Unplug size={16} />
                  Deconnexion
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
